'use strict';

import React from 'react';

require('styles/search/Results.css');

import ProductComponent from './ProductComponent'

class ResultsComponent extends React.Component {
  render() {
    var productComponents = [];
    var self = this;
    this.props.products.forEach(function(product, index){
      if (index % 6 == 0) {
        var keyName = 'visible-lg-block-'+index
        productComponents.push(<div className='clearfix visible-lg-block' key={keyName}></div>)
      }
      if (index % 4 == 0) {
        var keyName = 'visible-md-block-'+index
        productComponents.push(<div className='clearfix visible-md-block' key={keyName}></div>)
      }
      if (index % 3 == 0) {
        var keyName = 'visible-sm-block-'+index
        productComponents.push(<div className='clearfix visible-sm-block' key={keyName}></div>)
      }
      if (index % 2 == 0) {
        var keyName = 'visible-xs-block-'+index
        productComponents.push(<div className='clearfix visible-xs-block' key={keyName}></div>)
      }

      productComponents.push(<ProductComponent product={product} key={product.link} onClickProduct={self.props.onClickProduct}/>)
    });

    var titleStyle = {
      'text-align': 'center',
      'color': 'white'
    }
    var rowStyle = {
      '-moz-column-width': '25em',
      '-webkit-column-width': '25em',
      '-moz-column-gap': '.5em',
      '-webkit-column-gap': '.5em'
    }
    var coverStyle = {
      'color': 'grey',
      'paddingTop': "5em",
      'paddingBottom': "5em"
    }

    var titleText = ""
    if (this.props.isSearching){
      titleText = 'Searching for "' + this.props.searchTerm + '"...'
    } else if (this.props.searchTerm != '') {
      titleText = (this.props.products.length + ' Products found while searching for "'+this.props.searchTerm+'"')
    }

    var suggestionText = ""
    if (this.props.suggestTerm && this.props.suggestTerm.toLowerCase() != this.props.searchTerm.toLowerCase() && this.props.suggestTerm != ''){
      suggestionText = <h4 style={titleStyle}>Here's an idea! Try searching "{this.props.suggestTerm}" for more results</h4>
    }

    var zeroProductsCover = ""
    if (productComponents.length == 0) {
      zeroProductsCover = (
        <div className="row-fluid text-center">
          <div className="col-xs-10 col-xs-offset-1 col-lg-8 col-lg-offset-2" style={coverStyle}>
            <h1 className="cover-heading">Use the search bar above to find products</h1>
            <p className="lead">Protip: Use quotes "" to find exact matches, brackets ( ) to group related words, and | to indicate multiple options</p>
            <p>Try searching "ImmersionRC Vortex 250 Pro" or (tri | 3) blade</p>
          </div>
        </div>
      )
    }

    return (
      <div className='results-component container-fluid'>
        <h1 style={titleStyle}>{titleText}</h1>
        {suggestionText}
        <div className='row-fluid'>{productComponents}</div>
        {zeroProductsCover}
      </div>
    );
  }
}

ResultsComponent.displayName = 'SearchResultsComponent';

// Uncomment properties you need
// ResultsComponent.propTypes = {};
// ResultsComponent.defaultProps = {};

export default ResultsComponent;



/** WEBPACK FOOTER **
 ** ./src/components/search/ResultsComponent.js
 **/